var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 21 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--c-dark-blue3)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.816 9.097c0 4.912-6.315 9.122-6.315 9.122s-6.315-4.21-6.315-9.122a6.315 6.315 0 1 1 12.63 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--c-dark-blue3)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.502 11.201a2.105 2.105 0 1 0 0-4.21 2.105 2.105 0 0 0 0 4.21"
  })));
};
export default SvgLocation;